module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsSAAALEgHS3X78AAAA40lEQVQ4y53UsRGCMBTG8X9S0LIChQMwArakcQPpXMfWDjawCLZmBBZwCFoaLMx5mIPk4evyyP2OF76grO0LoOFTd2PqAWH1/aMETn7ZKmv7Cnj6xghUEtBDDsh966iDPTng/MY9EADamNoBnRTcgDpjaqcBjKkbCRiBGoDvmCkwBQGoeZ7DMVrgvGiNwAW4xaBVbAOcARWDfsZc1srISWgT83UFpqA3+T5ibHHYWfAoi8VGC3P0kuRQC3N0kORQSwMpCbaWBlICKv8LGlKQINilBoo9UOQNi/BrJqEIuH6d/q03tTWOcZ1ScWIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cancle.png
// module id = Z/oZ
// module chunks = 1